import { type LoaderFunctionArgs, useLoaderData, useNavigate } from 'react-router-dom'

import { IconEdit } from '../components/icon-edit'
import { trpc } from '../trpc'

export async function loader({ params }: LoaderFunctionArgs) {
	const { websiteID } = params
	if (!websiteID) {
		throw new Error('400 Bad Request')
	}

	const website = await trpc().WebsiteService.Get.query(websiteID)
	if (!website) {
		throw new Error('404 Not Found')
	}

	const { route_list } = await trpc().WebsiteService.ListRoutes.query({ website_id: website.id })

	const custom_hostname_list = await Promise.all(
		route_list
			.filter((route) => Boolean(route.custom_hostname_id))
			.map((route) => trpc().CloudflareService.GetCustomHostname.query(route.custom_hostname_id!))
	)

	return { website, route_list, custom_hostname_list }
}

export function Website() {
	const navigate = useNavigate()
	const { website, route_list, custom_hostname_list } = useLoaderData() as Awaited<ReturnType<typeof loader>>

	return (
		<div className="p-4 w-full max-w-md">
			<div className="mb-4 flex justify-between">
				<h1 className="text-4xl truncate">{website.name}</h1>

				<button
					className="ml-4 btn btn-ghost"
					onClick={() => navigate(`edit`)}
				>
					<IconEdit size={18} />
					<span className="font-semibold">Edit</span>
				</button>
			</div>
			<nav>
				<ul className="flex flex-col gap-4">
					{route_list.map((route, i) => (
						<div className="p-4 flex flex-col items-center gap-2 rounded-2xl bg-[#F5F5FF] outline-0 hover:bg-[#EBEBFF] focus:ring-4 focus:ring-opacity-50 focus:ring-[#FF73E1]">
							<div className="flex">{route.hostname}</div>
							{Boolean(route.custom_hostname_id) && Boolean(custom_hostname_list[i]) && (
								<>
									<div className="flex">{custom_hostname_list[i]!.status}</div>
									<div className="flex">{custom_hostname_list[i]!.ownership_verification?.type}</div>
									<div className="flex">{custom_hostname_list[i]!.ownership_verification?.name}</div>
									<div className="flex">{custom_hostname_list[i]!.ownership_verification?.value}</div>
									<div className="flex">{custom_hostname_list[i]!.ssl.status}</div>
									<div className="flex">{custom_hostname_list[i]!.ssl.txt_name}</div>
									<div className="flex">{custom_hostname_list[i]!.ssl.txt_value}</div>
								</>
							)}
						</div>
					))}
				</ul>
			</nav>
		</div>
	)
}
